(() => {
  const checkoutButtonSelector = '.shopify-payment-button__button--unbranded';

  const setRedirectingState = (button) => {
    if (!button || button.disabled || button.classList.contains('is-redirecting')) return;

    button.classList.add('is-redirecting');
    button.setAttribute('aria-busy', 'true');
    button.setAttribute('aria-label', 'Redirigiendo al pago');
  };

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest(checkoutButtonSelector);
      if (button) setRedirectingState(button);
    },
    true
  );

  window.addEventListener('pageshow', () => {
    document.querySelectorAll(`${checkoutButtonSelector}.is-redirecting`).forEach((button) => {
      button.classList.remove('is-redirecting');
      button.removeAttribute('aria-busy');
      button.removeAttribute('aria-label');
    });
  });
})();
